import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <>
      <title>页面未找到 - 韩漫漫画网</title>
      <meta name="description" content="抱歉，您访问的页面不存在。返回韩漫漫画网首页继续免费韩漫阅读。" />
      <meta name="robots" content="noindex, follow" />
      <Navbar />
      <main className="pt-20 min-h-screen flex items-center justify-center bg-background-50">
        <div className="text-center px-4">
          <div className="w-28 h-28 mx-auto mb-8 rounded-full bg-background-200 flex items-center justify-center">
            <i className="ri-emotion-sad-line text-foreground-400 text-5xl"></i>
          </div>
          <h1 className="font-heading text-5xl md:text-7xl font-bold text-foreground-950 mb-3">404</h1>
          <p className="text-foreground-500 text-base mb-8">抱歉，您访问的页面不存在或已下架</p>
          <div className="flex items-center justify-center gap-3 flex-wrap">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-3 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-home-line"></i> 返回首页
            </Link>
            <Link
              to="/category/remen"
              className="inline-flex items-center gap-2 bg-background-200 text-foreground-700 px-6 py-3 rounded-full text-sm font-medium hover:bg-background-300 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-book-open-line"></i> 浏览漫画
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}